import Dexie from 'dexie';
import { IContact } from './model/contact';
import { IDBMessage } from './model/dbMessage';
import { IMessageDetail } from './model/messageDetails';
import { IContactGiaThuong } from './model/contactGiaThuong';
import { IContactsConfig } from './model/contactConfig';
import { IUserDaiConfig } from './model/userDaiConfig';
import { IUserConfig } from './model/userConfig';
import { ITuKhoaRieng } from './model/tuKhoaRieng';
import { IDaiGioChot, IDmDai } from './model/dmdai';
import { KetQuaKey } from './model/ketQuaTrung';
import { IKetQua } from './model/ketqua';
import { ICanChuyenParamGroup } from './model/canChuyenParamGroup';
import { INgoaiLe } from './model/ngoaiLe';
import { IErrorLog } from './model/errorLogs';
import { IHanMucRieng } from './model/hanmucrieng';
import { IChatSyncState } from './model/chatSyncState';
import { WireMessage } from '../websocket/wsTypes';
import { TelegramMessageRecord } from './gotd';
export class Dexiedb extends Dexie {
    static instance: Dexiedb;
    contacts!: Dexie.Table<IContact, any>; // any = type of the primkey
    contactGiaThuong!: Dexie.Table<IContactGiaThuong, any>;
    contactsConfig!: Dexie.Table<IContactsConfig, any>;
    dbmessages!: Dexie.Table<IDBMessage, any>;
    messageDetails!: Dexie.Table<IMessageDetail, any>;
    userDaiConfig!: Dexie.Table<IUserDaiConfig, any>;
    userConfig!: Dexie.Table<IUserConfig, any>;
    tuKhoaRieng!: Dexie.Table<ITuKhoaRieng, any>;
    dmDai!: Dexie.Table<IDmDai, any>;
    daiGioChot!: Dexie.Table<IDaiGioChot, any>;
    ketQuaTrung!: Dexie.Table<KetQuaKey, any>;
    ketQua!: Dexie.Table<IKetQua, any>;
    canChuyenParamGroup!: Dexie.Table<ICanChuyenParamGroup, any>;
    ngoaiLe!: Dexie.Table<INgoaiLe, any>;
    errorLogs!: Dexie.Table<IErrorLog, any>;
    messages!: Dexie.Table<any, any>;
    editedMessages!: Dexie.Table<any, any>;
    deletedMessages!: Dexie.Table<any, any>;
    hanMucRieng!: Dexie.Table<IHanMucRieng, any>;
    chatSyncState!: Dexie.Table<IChatSyncState, any>;
    telegramMessage!: Dexie.Table<TelegramMessageRecord, any>;
    constructor() {
        super("MyDatabase");
        this.version(16).stores({
            contacts: 'contactId, userId, phone, tlUserId,name',
            contactGiaThuong: `[mienCuPhapId+mienDaiCuocId+loaiCuocId+contactId],contactId, mienCuPhapId, mienDaiCuocId, loaiCuocId`,
            contactsConfig: '[contactId+mienCuPhapId+tinhId],contactId, mienCuPhapId, tinhId',
            messageDetails: `++messageDetailsId, daiId1, daiId2, loaiCuocId, 
                [messageId+mienDaiCuocId], soCuoc, soNhayTrung, lenSoCuoc, mienDaiCuocId, messageId`,
            dbmessages: `++messageId,userId, contactId, date, time, type, mienCuPhapId,[userId+tlChatId+tlMessageId],
                [date+contactId],[date+userId],
                textChecksum, dataChecksum, tlChatId, tlMessageId`,
            canChuyenParamGroup: "[contactId+daiId+groupId+subGroup+mienCuPhapId]",
            dmTinh: "tinhId",
            dmDai: "daiId,mienDaiCuocId",
            userDaiConfigPredef: '[tinhId+thu]',
            userDaiConfig: '[tinhId+thu]',
            daiNgayQuay: '[thu+daiId]',
            userConfig: 'tinhId',
            contactsConfigPredef: 'tinhId',
            chats: 'id',
            messages: '[chatId+id],chatId,textChecksum', // tele messages
            messagesParsed: '[chatId+id]',
            deletedMessages: '[chatId+id],chatId',
            editedMessages: '[chatId+id+editDate],chatId',
            tuKhoaRieng: '[userId+mienCuPhapId+tuKhoa]',
            ketQuaTrung: '[area+loaicuoc+socuoc+ngay]',
            ketQua: '[area+ngay+tengiai],ngay',
            ngoaiLe: 'contactId',
            errorLogs: '++id',
            daiGioChot: '[userId+daiId],userId,daiId',
            hanMucRieng: '[contactId+mienCuPhapId+daiId+loaiCuocId],thu',
            chatSyncState: '[ownerId+chatId], ownerId, chatId, lastSyncedMessageId',
            telegramMessage: '[ownerId+chatId+messageId], ownerId, chatId,date, [ownerId+chatId],[chatId+messageId]',
        });
    }
    static getInstance(): Dexiedb {
        if (!Dexiedb.instance) {
            Dexiedb.instance = new Dexiedb();
        }
        if (this.instance.isOpen() == false)
            this.instance.open()
        return Dexiedb.instance;
    }
}

